import cx from 'classnames';
import {
  FC, ReactElement, useCallback, useMemo, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { getCityRequested } from '../../../../redux/actions/admin-page';
import { RootState } from '../../../../redux/reducers/rootReducer';
import { IFilterSelectsUIData } from '../../../../utils/constants/filter-selects';
import { ICity } from '../../../../utils/types/admin-types';
import { useDebounceCallback } from '../../../../utils/useDebounceCallback';
import SearchIcon from '../../../SVGIcons/SearchIcon';
import { CheckboxNew } from '../../../UI/CheckboxNew';
import Search from '../../../UI/Search';
import classes from './FilterСategory.module.scss';
import { FilterCategoryProps } from './FilterСategory.types';

export const FilterСategory: FC<FilterCategoryProps> = ({
  className,
  category,
  values,
  onChangeCheckbox,
}): ReactElement => {
  const renderIcon = useCallback(() => <SearchIcon fill="black" />, []);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [textSearch, setTextSearch] = useState<string>('');

  const cities = useSelector<RootState, ICity[] | []>(
    (state) => state.cityReducer.city,
  );
  const isSearch = category === 'role' || category === 'city';

  const handleSearchRequest = useDebounceCallback(
    (searchValue: string) => {
      switch (category) {
        case 'city':
          dispatch(getCityRequested({ search: searchValue.trim() }));
          break;
        default:
      }
    },
    500,
    [],
  );

  const handleSearch = (searchValue: string) => {
    setTextSearch(searchValue);
    handleSearchRequest(searchValue);
  };

  const searchValues: IFilterSelectsUIData[] = useMemo(() => {
    switch (category) {
      case 'role': {
        return values.filter((item) => item.name?.toUpperCase().includes(textSearch.trim().toUpperCase()));
      }
      case 'city': {
        const selectedCities = searchParams?.getAll('city')[0]?.split(',') || [];
        return cities.map((role) => ({
          ...role,
          displayName: role.name,
          isSelected: selectedCities.includes(role.name),
          show: true,
        }));
      }
      default:
        return [];
    }
  }, [category, cities, searchParams, textSearch, values]);

  return (
    <div
      className={cx(
        classes['filter-category'],
        { [classes['filter-category--with-search']]: isSearch },
        className,
      )}
    >
      {isSearch && (
        <div className={classes['filter-category__search-wrapper']}>
          <Search
            className={classes['filter-category__search']}
            icon={renderIcon}
            title={textSearch || 'Поиск'}
            onSearch={handleSearch}
            variant="small"
          />
        </div>
      )}
      <div className={classes['filter-category__scroll']}>
        <ul className={classes['filter-category__list']}>
          {(textSearch ? searchValues : values).map((item) => (
            <li key={item?.id} className={classes['filter-category__item']}>
              <CheckboxNew
                className={classes['filter-category__checkbox']}
                onChange={() => onChangeCheckbox(item, category, !!textSearch)}
                value="1"
                isSelected={item.isSelected}
                isDisabled={!item.isSelected && !item.show}
              >
                {item.displayName || item.name}
              </CheckboxNew>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
